function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { enterpriseLogApi } from '@/api/enterprise';
import oaFromBox from '@/components/common/oaFromBox';
export default {
  name: 'SystemLog',
  components: {
    oaFromBox: oaFromBox
  },
  data: function data() {
    return {
      total: 0,
      formData: {
        user_name: '',
        path: '',
        event_name: '',
        time: '',
        page: 1,
        limit: 20
      },
      value1: [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')],
      pickerOptions: this.$pickerOptionsTimeEle,
      methodOpts: [{
        value: '选项1',
        label: '黄金糕'
      }, {
        value: '选项2',
        label: '双皮奶'
      }, {
        value: '选项3',
        label: '蚵仔煎'
      }, {
        value: '选项4',
        label: '龙须面'
      }, {
        value: '选项5',
        label: '北京烤鸭'
      }],
      tableData: [],
      searchData: [{
        field_name: '用户行为',
        field_name_en: 'event_name',
        form_value: 'input'
      }, {
        field_name: '开始时间',
        field_name_end: '结束时间',
        field_name_en: 'time',
        form_value: 'date_picker'
      }]
    };
  },
  created: function created() {
    this.formData.limit = Math.floor((window.innerHeight - 320) / 44);
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    search: function search() {
      if (this.value1 != '') {
        var time = this.value1.join('-');
        this.formData.time = time;
      }
      this.formData.page = 1;
      this.getList();
    },
    reset: function reset() {
      this.value1 = '';
      this.formData.event_name = '';
      this.value1 = [this.$moment().startOf('month').format('YYYY/MM/DD'), this.$moment().endOf('month').format('YYYY/MM/DD')], this.formData.time = this.$moment().startOf('month').format('YYYY/MM/DD') + '-' + this.$moment().endOf('month').format('YYYY/MM/DD');
      this.getList();
    },
    getList: function getList() {
      var _this = this;
      enterpriseLogApi(this.formData).then(function (res) {
        _this.tableData = res.data.list;
        _this.total = res.data.count;
      });
    },
    handleSizeChange: function handleSizeChange(num) {
      this.formData.limit = num;
      this.getList();
    },
    pageChange: function pageChange(num) {
      this.formData.page = num;
      this.getList();
    },
    confirmData: function confirmData(data) {
      if (data == 'reset') {
        this.formData = {
          page: 1,
          limit: 15,
          event_name: '',
          time: ''
        };
        this.getList();
      } else {
        this.formData = _objectSpread(_objectSpread({}, this.formData), data);
        this.formData.page = 1;
        this.getList();
      }
    }
  }
};